<template>
  <div class="appLoginContainer">
    <div class="appMain">
      <div class="loginForm">
        <img style="width: 100%; margin-bottom: 20px" src="../../../assets/img/app-login-title.png" />
        <el-form ref="el_form" label-position="top" :model="form" :rules="rules" @keyup.enter.native="handle_login">
          <el-row>
            <el-col :span="24">
              <el-form-item prop="username">
                <!-- autofocus 进入页面后聚焦，可直接按回车登录 -->
                <el-input id="userName" autofocus v-model="form.username" placeholder="请输入用户名" clearable>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="password">
                <el-input v-model="form.password" type="password" placeholder="请输入密码" clearable> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24"> <el-checkbox v-model="isRemember">记住用户名和密码</el-checkbox></el-col>
            <el-col :span="24">
              <div class="buttonContainer">
                <el-button :loading="login_state" round type="primary" @click="handle_login">登录</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="copyright">
      <span>CopyRight © 2023 福州国电远控</span>
    </div>

    <!-- 个人信息弹窗 -->
    <ChangePwd ref="ChangePwdRef" />
  </div>
</template>
<script>
import ChangePwd from '@/components/app/changePwd.vue'
let Base64 = require('js-base64').Base64

export default {
  components: {
    ChangePwd
  },
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      // 是否记住用户名和密码
      isRemember: false,
      rules: {
        username: [
          // { required: true, message: '请输入用户名', trigger: 'change' }
          { validator: this.validUsername, trigger: 'change' }
        ],
        password: [
          // { required: true, message: '请输入密码', trigger: 'change' },
          {
            min: 1,
            max: 16,
            message: '长度在 1 到 16 个字符',
            trigger: 'blur'
          },
          { validator: this.validPassword, trigger: 'change' }
        ]
      },
      // 登录加载状态
      login_state: false
    }
  },
  methods: {
    // 登录
    handle_login() {
      if (this.$route.path !== '/Login') {
        return
      }
      this.$refs['el_form'].validate(async valid => {
        if (!valid) {
          this.$message.error('登陆失败, 请检查输入是否有误!')
          return
        }
        const username = this.form.username
        // 会被转为md5的密码
        let password = this.form.password
        // md5转换前的密码
        let noMD5pwd = password

        password = this.$md5.md5(password)
        // 暂时使用
        const { data: res } = await this.$http.post('/login', {
          userName: username,
          password: password
        })

        if (res.isSuccess) {
          // token
          this.$store.commit('set_accessToken', res.data.accessToken)
          this.$store.commit('set_refreshToken', res.data.refreshToken)
          let expiredTime = new Date().getTime() + res.data.expire * 60 * 1000
          this.$store.commit('set_expirationTime', expiredTime)
          this.$store.commit('set_effectiveMinutes', res.data.expire)

          // 用户信息
          this.$store.commit('set_userInfo', {
            userId: res.data.id,
            name: res.data.name,
            role: res.data.role,
            authority: res.data.authority,
            dept_name: res.data.dept_name
          })
          let lastPasswordModifyTime = res.data.lastPasswordModifyTime
          let passwordExpireDays = res.data.passwordExpireDays
          sessionStorage.setItem('state', JSON.stringify(this.$store.state))
          if (passwordExpireDays > 0 && this.isPasswordExpired(lastPasswordModifyTime, passwordExpireDays)) {
            this.$refs.ChangePwd.formVisible = true
          } else {
            this.setStorage(username, noMD5pwd)
            this.$message.success('登陆成功')
            this.$router.push('/Home')
          }
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    // 校验用户名
    validUsername(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    },
    // 校验密码
    validPassword(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    },
    // 密码是否过期
    isPasswordExpired(lastPasswordModifyTime, passwordExpireDays) {
      let expiredTime = this.$utils.getWhatDay(lastPasswordModifyTime, passwordExpireDays)
      let nowTime = new Date().getTime()
      return expiredTime <= nowTime
    },
    // 设置缓存 [是否记住用户名和密码 | 用户名 | 密码]
    setStorage(username, password) {
      localStorage.setItem('userName', username)
      localStorage.setItem('password', Base64.encode(password))
      // 将是否记住密码存为缓存
      localStorage.setItem('isRemember', this.isRemember)
    },
    // 获取缓存值
    getStorage() {
      const isStorageRemember = localStorage.getItem('isRemember')
      if (isStorageRemember === 'true') {
        this.isRemember = true
      } else {
        this.isRemember = false
      }
      // 如果用户勾选了要记住用户名密码，且存在缓存则直接赋值
      if (this.isRemember && localStorage.getItem('userName') && localStorage.getItem('password')) {
        this.form.username = localStorage.getItem('userName')
        this.form.password = Base64.decode(localStorage.getItem('password'))

        this.handle_login()
      }
    }
  },
  mounted() {
    this.getStorage()
  }
}
</script>
<style lang="less" scoped>
.flexXY(@x: center, @y: center) {
  display: flex;
  justify-content: @x;
  align-items: @y;
}

.appLoginContainer {
  height: 100vh;
  width: 100vw;
  .appMain {
    height: calc(90% - 100px);
    width: 100%;
    margin-bottom: 100px;

    display: flex;
    flex: none;
    justify-content: center;
    align-items: center;

    box-sizing: border-box;
    padding: 0 10%;

    .loginForm {
      width: 100%;

      .el-col {
        box-sizing: border-box;
        padding: 0 20px;
      }

      /deep/ .el-form-item__label {
        padding: 0 !important;
        font-size: 17px !important;
        font-weight: 500;
        color: #000;
      }
      /deep/ .el-input__inner {
        border: 0 !important;
        border-bottom: 1px solid #d1d1d1 !important;
        border-radius: 0;
        padding-left: 0 !important;
        transition: all 0.3s;
      }
      // /deep/ .el-input__inner:hover {
      //   padding-left: 10px !important;
      //   transition: all 0.3s;
      // }
      /deep/ .el-input__inner:focus {
        padding-left: 10px !important;
        transition: all 0.3s;
      }
      .buttonContainer {
        width: 100%;
        margin-top: 40px;
        .flexXY;
        .el-button {
          width: 100%;
          height: 40px;
          border-radius: 50px;
          font-size: 16px;
        }
      }
    }
  }
  .copyright {
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #999;
  }
}
</style>
